import React, { useState, useEffect, useCallback } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const ColumnScrollNav = ({ targetId }) => {
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);

  const checkScroll = useCallback(() => {
    const el = document.getElementById(targetId);
    if (!el) return;
    const atTop = el.scrollTop < 80;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    setShowTop(!atTop);
    setShowBottom(!atBottom);
  }, [targetId]);

  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return;
    // Add relative positioning so our absolute buttons anchor to the column
    el.style.position = 'relative';
    checkScroll();
    el.addEventListener('scroll', checkScroll, { passive: true });
    const observer = new MutationObserver(checkScroll);
    observer.observe(el, { childList: true, subtree: true });
    return () => {
      el.removeEventListener('scroll', checkScroll);
      observer.disconnect();
    };
  }, [targetId, checkScroll]);

  const scrollTo = (position) => {
    const el = document.getElementById(targetId);
    if (!el) return;
    el.scrollTo({ top: position === 'top' ? 0 : el.scrollHeight, behavior: 'smooth' });
  };

  if (!showTop && !showBottom) return null;

  return (
    <div className="hidden sm:flex flex-col gap-1 sticky bottom-3 z-40 ml-auto mr-1 w-fit pointer-events-none"
      style={{ marginTop: '-60px' }}>
      <div className="flex flex-col gap-1 pointer-events-auto">
        {showTop && (
          <button onClick={() => scrollTo('top')} data-testid={`${targetId}-scroll-top`}
            className="w-7 h-7 rounded-full bg-card/90 border border-border shadow-md flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors backdrop-blur-sm">
            <ChevronUp className="w-4 h-4" />
          </button>
        )}
        {showBottom && (
          <button onClick={() => scrollTo('bottom')} data-testid={`${targetId}-scroll-bottom`}
            className="w-7 h-7 rounded-full bg-card/90 border border-border shadow-md flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors backdrop-blur-sm">
            <ChevronDown className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ColumnScrollNav;
